import { ApolloClient, InMemoryCache } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import { SetContextLink } from '@apollo/client/link/context';
import { getToken } from '../storage/tokenStorage';

const httpLink = new HttpLink({
  uri: '/graphql',
});

const authLink = new SetContextLink((prevContext, operation) => {
  const token = getToken();
  return {
    ...prevContext,  
    headers: {
      ...prevContext.headers, 
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all", 
    },
  },
});